import { Divider } from "react-native-paper";
import { useAppTheme } from "../../../useAppTheme";
import { useDevice } from "../../../useDevice";
import Box from "../../Box";
import { FlatCard } from "../../Cards/FlatCard";
import { Skeleton } from "../../Skeleton";
import { StatsSkeleton } from "../StatsSkeleton";

type Props = {
	showScoreRanges?: boolean;
	numScoreRanges?: number;
};

export const SummaryCardSkeleton = ({
	showScoreRanges = true,
	numScoreRanges = 3,
}: Props) => {
	const theme = useAppTheme();
	const { isMobile } = useDevice();

	const hasScoreRanges = numScoreRanges > 0;
	const showScoreRangesRow = hasScoreRanges && showScoreRanges;

	return (
		<FlatCard
			style={{
				width: "100%",
			}}
		>
			<Box gap={16}>
				<Box
					gap={16}
					flexDirection="column"
					alignItems="center"
					position="relative"
				>
					<Box
						top={-54}
						backgroundColor={theme.colors.elevation.level1}
						position="absolute"
						alignSelf="center"
						width={100}
						height={100}
						borderRadius={50}
						zIndex={1}
						padding={8}
						alignItems="center"
						justifyContent="center"
					>
						<Skeleton variant="circle" size={84} />
					</Box>

					{showScoreRangesRow ? (
						<Box
							flexDirection="row"
							gap={16}
							paddingTop={60}
							alignItems="center"
						>
							{[...new Array(numScoreRanges).keys()].map((item) => (
								<Box key={item} height={16} justifyContent="center">
									<Skeleton width={56} height={12} />
								</Box>
							))}
						</Box>
					) : (
						<Box height={40} />
					)}

					<Box gap={8} alignItems="center" paddingTop={hasScoreRanges ? 0 : 58}>
						<Box height={24} justifyContent="center">
							<Skeleton width={200} height={16} />
						</Box>
						<Box height={24} justifyContent="center">
							<Skeleton width={160} height={14} />
						</Box>
					</Box>

					{!isMobile && <Skeleton width={120} height={40} borderRadius={20} />}
				</Box>

				<Divider />
			</Box>

			<StatsSkeleton numRows={3} />
		</FlatCard>
	);
};
